import { colors as zetColors } from '@zet/design-system'
import { Alert } from '@zet/design-system/alert'
import { i18n } from '@zet/localization'
import { HDFC_ASKCODES, LeadStatus } from '@zet/utils/Constants'
import moment from 'moment'

interface ReportAlertProps {
  brandName: string
  item?: object
  brandComms?: object
  askCode: string
}

const ReportAlert: React.FC<ReportAlertProps> = (props) => {
  const { item, brandName, brandComms, askCode } = props

  if (askCode === HDFC_ASKCODES.$ARN_REQUIRED) {
    return (
      <Alert
        iconLeft={{ name: 'InfoOutlined', color: zetColors.warning[150] }}
        className="bg-warning-10 items-center px-3 py-2"
      >
        {brandComms?.ARN?.updateARNMessage}
      </Alert>
    )
  } else if (askCode === HDFC_ASKCODES.$ARN_INCORRECT) {
    return (
      <Alert
        iconLeft={{ name: 'ErrorOutlined', color: zetColors.error[150] }}
        className="bg-error-10 items-center px-3 py-2"
      >
        {brandComms?.ARN?.failedARNMessage}
      </Alert>
    )
  } else if (
    (item?.status === LeadStatus.LEAD_ADDED ||
      item?.status === LeadStatus.ACTION_REQUIRED) &&
    item?.isReportDelayed
  ) {
    return (
      <Alert
        iconLeft={{ name: 'CautionOutlined', color: zetColors.error[100] }}
        className="bg-error-10 items-center px-3 py-2"
        intent="error"
      >
        {i18n.t('leads.reportDelayedDescription', {
          brandName: brandName ?? '',
          date: moment.utc(item?.nextUpdateDate).format('DD-MMM-YYYY'),
        })}
      </Alert>
    )
  } else if (
    item?.status === LeadStatus.LEAD_ADDED ||
    item?.status === LeadStatus.ACTION_REQUIRED
  ) {
    return (
      <Alert
        iconLeft={{ name: 'CalenderOutlined' }}
        className="items-center px-3 py-2"
      >
        {i18n.t('leads.reportDescription', {
          lastUpdatedDate: moment
            .utc(item?.lastUpdatedDate)
            ?.format('DD-MMM-YYYY'),
          nextUpdatedDate: moment
            .utc(item?.nextUpdateDate)
            ?.format('DD-MMM-YYYY'),
        })}
      </Alert>
    )
  } else {
    return null
  }
}

export default ReportAlert
